import VueRouter, { RouteConfig } from 'vue-router'
import { GlobalConfigRouteMetaEnum, ICourseScheduleItem } from 'kuaidong-model'

const List = () => import('../views/online-course/List.vue')
const ListAll = () => import('../views/online-course/ListAll.vue')
const Assign = () => import('../views/online-course/Assign.vue')
const Details = () => import('../views/online-course/Details.vue')
const AssignPreview = () => import('../views/online-course/AssignPreview.vue')
const HomeworkAssignStep1 = () => import('../views/online-course/HomeworkAssignStep1.vue')
const HomeworkAssignStep2 = () => import('../views/online-course/HomeworkAssignStep2.vue')
const HomeworkAssignStep3 = () => import('../views/online-course/HomeworkAssignStep3.vue')
const CourseStatisticsDetail = () => import('../views/online-course/LiveCourseStatistics.vue')
const CourseDetail = () => import('../views/online-course/LiveCourseDetail.vue')
const LessonDetail = () => import('../views/online-course/LiveCourseLessonDetail.vue')
const LiveCourseLessonDetailStudentStatics = () =>
  import('../views/online-course/LiveCourseLessonDetailStudentStatics.vue')

const LiveCourseLessonDetailClazzStatics = () => import('../views/online-course/LiveCourseLessonDetailClazzStatics.vue')
const liveCourseLessonsOperation = () => import('../views/online-course/OperationOfCourse.vue')

const LiveCourseRecordPage = () => import('../views/online-course/LiveCourseRecordsPage.vue')
const LiveCourseDrillReportPage = () => import('../views/online-course/LiveCourseDrillReportPage.vue')

export const listRoute: RouteConfig = {
  path: '/online-course-list',
  name: 'online_course_list',
  component: List,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '我的体育课',
    ignoreLogin: true,
  },
}

export const listAllRoute: RouteConfig = {
  path: '/online-course-list-all',
  name: 'online_course_list_all',
  component: ListAll,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '全部体育课',
  },
}

export const assignRoute: RouteConfig = {
  path: '/online-course-assign',
  name: 'online_course_assign',
  component: Assign,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '课程布置',
  },
}

export const detailsRoute: RouteConfig = {
  path: '/online-course-details',
  name: 'online_course_details',
  component: Details,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '课程详情',
    ignoreLogin: true,
  },
}

export const assignPreviewRoute: RouteConfig = {
  path: '/online-course-assign-preview',
  name: 'online_course_assign_preview',
  component: AssignPreview,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '课程预览',
  },
}

export const courseStatisticsRoute: RouteConfig = {
  path: '/online-course-statistics-detail',
  name: 'online_course_statistics_detail',
  component: CourseStatisticsDetail,
  props: (route) => ({
    ...route.query,
    ...route.params,
    clazzId: route.query.clazzId === 'null' ? null : Number(route.query.clazzId),
  }),
  meta: {
    title: '课程详情',
    [GlobalConfigRouteMetaEnum.Drills]: true,
  },
}

export const courseDetailRoute: RouteConfig = {
  path: '/online-course-detail',
  name: 'online_course_detail',
  component: CourseDetail,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '课程详情',
  },
}

export const liveCourseRecordRoute: RouteConfig = {
  path: '/online-course-record',
  name: 'online_course_record',
  component: LiveCourseRecordPage,
  props: (route) => ({
    ...route.query,
    ...route.params,
    student: JSON.parse(route.query.student as string),
    isOldCourse: JSON.parse(route.query.isOldCourse as string),
  }),
  meta: {
    title: '个人记录',
  },
}

export const liveCourseDrillReportRoute: RouteConfig = {
  path: '/online-course-drill-report',
  name: 'online_course_drill_report',
  component: LiveCourseDrillReportPage,
  props: (route) => ({
    ...route.query,
    ...route.params,
    student: JSON.parse(route.query.student as string),
  }),
  meta: {
    title: '训练报告',
  },
}

export const lessonDetailRoute: RouteConfig = {
  path: '/online-course-lesson-detail',
  name: 'online_course_lesson_detail',
  component: LessonDetail,
  props: (route) => ({
    ...route.query,
    ...route.params,
    lessonDetail: JSON.parse(route.query.lessonDetail as string),
  }),

  children: [
    {
      path: 'clazz-info',
      name: 'online_course_lesson_detail_clazz_statistic',
      component: LiveCourseLessonDetailClazzStatics,
      meta: {
        title: '课节详情',
      },
    },
    {
      path: 'student-info',
      name: 'online_course_lesson_detail_student_statistic',
      component: LiveCourseLessonDetailStudentStatics,
      meta: {
        title: '课节详情',
      },
    },
  ],
  meta: {
    title: '课节详情',
  },
}

export const assignHomeworkStep1Route: RouteConfig = {
  path: '/homework-assign-step1',
  name: 'homework_assign_step1',
  component: HomeworkAssignStep1,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '布置作业',
  },
}

export const assignHomeworkStep2Route: RouteConfig = {
  path: '/homework-assign-step2',
  name: 'homework_assign_step2',
  component: HomeworkAssignStep2,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '布置作业',
  },
}

export const assignHomeworkStep3Route: RouteConfig = {
  path: '/homework-assign-step3',
  name: 'homework_assign_step3',
  component: HomeworkAssignStep3,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '作业预览',
  },
}

export const liveCourseLessonsOperationRoute: RouteConfig = {
  path: '/live-course-lesson-operation',
  name: 'live_course_lesson_operation',
  component: liveCourseLessonsOperation,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '课程安排',
  },
}

export default [
  listRoute,
  listAllRoute,
  assignRoute,
  detailsRoute,
  assignPreviewRoute,
  courseStatisticsRoute,
  courseDetailRoute,
  lessonDetailRoute,
  liveCourseRecordRoute,
  liveCourseDrillReportRoute,
  assignHomeworkStep1Route,
  assignHomeworkStep2Route,
  assignHomeworkStep3Route,
  liveCourseLessonsOperationRoute,
]

export function navigateToOnlineCourseList(router: VueRouter, tab: string) {
  return router.push({ name: listRoute.name, query: { tab } })
}

export function navigateToOnlineCourseAssign(router: VueRouter) {
  return router.push({ name: assignRoute.name })
}

export function redirectToOnlineCourseAssign(
  router: VueRouter,
  homeworkTemplateId?: string,
  repoItemId?: string,
  title?: string
) {
  return router.replace({ name: assignRoute.name, query: { homeworkTemplateId, repoItemId, title } })
}

export function navigateToOnlineCourseDetails(router: VueRouter, id: string) {
  return router.push({ name: detailsRoute.name, query: { id } })
}

export function navigateToOnlineCourseAssignPreview(router: VueRouter) {
  return router.push({ name: assignPreviewRoute.name })
}

export function redirectToOnlineCourseAssignPreview(router: VueRouter, homeworkTemplateId?: string) {
  return router.replace({ name: assignPreviewRoute.name, query: { homeworkTemplateId } })
}

export function navigateToOnlineCourseDetail(router: VueRouter, id: string) {
  return router.push({ name: courseDetailRoute.name, query: { id } })
}

export function navigateToOnlineCourseStatisticsDetail(router: VueRouter, id: string, clazzId: number) {
  return router.push({ name: courseStatisticsRoute.name, query: { id, clazzId: String(clazzId) } })
}

export function navigateToOnlineCourseLessonDetail(router: VueRouter, lessonDetail: ICourseScheduleItem) {
  return router.push({ name: lessonDetailRoute.name, query: { lessonDetail: JSON.stringify(lessonDetail) } })
}

export function navigateToLiveCourseDrillReportRoute(
  router: VueRouter,
  id: string,
  live_rank_id: string,
  student: string
) {
  router.push({
    name: liveCourseDrillReportRoute.name,
    query: { itemId: id, live_rank_id, student },
  })
}
